// eventsystem.ts

type Tpayload = { id:number|string, [key:string]:any }
export type DevEvent =
  | { type: "log"; payload:Tpayload }
  | { type: "error"; payload:Tpayload }
  | { type: "table"; payload:Tpayload }
  | { type: "image"; payload:Tpayload }
  | { type: "custom"; payload:Tpayload }
  | { type: "divider"; payload:Tpayload }
  | { type: "headline"; payload:Tpayload }
  | { type: "clear"; payload:{} };


type Listener = (event: DevEvent) => void;

const listeners = new Set<Listener>();

export const eventsystem = {
  publish(event: DevEvent) {
    listeners.forEach((cb) => cb(event));
  },
  subscribe(cb: Listener) {
    listeners.add(cb);
    return () => listeners.delete(cb);
  }
};

// export const announce = (payload:Tpayload) => {
//   eventsystem.publish({ type: "log", payload });
// }
